import React, { useEffect, useRef } from 'react';

const Partners = () => {
  const scrollRef = useRef(null);

  const partnerLogos = [
    'accops.png', 'acer.png', 'acronis.png', 'aws.png', 'aruba.png',
    'checkpoint.png', 'cisco.png', 'cs.png', 'dell.png', 'eset.png',
    'everest.png', 'fortinet.png', 'google.png', 'hp.png', 'kaspersky.png',
    'lenovo.png', 'mcafee.png', 'microsoft.png', 'azure.png', 'ng.png',
    'ol.png', 'prophaze.png', 'qnap.png', 'quantum.png', 'rapid.png',
    'rediff.png', 'ruckus.png', 'safetica.png', 'seceon.png', 'sify.png',
    'sonicwall.png', 'sophos.png', 'soti.png', 'synology.png', 'tenable.png',
    'trellix.png', 'veeam.png', 'veritas.png', 'webworks.png', 'zoho.png'
  ];

  useEffect(() => {
    const scroll = scrollRef.current;
    if (!scroll) return;

    let scrollAmount = 0;
    const scrollSpeed = 0.5;

    const scrollInterval = setInterval(() => {
      scrollAmount += scrollSpeed;
      if (scroll.scrollLeft >= scroll.scrollWidth / 2) {
        scrollAmount = 0;
        scroll.scrollLeft = 0;
      }
      scroll.scrollLeft = scrollAmount;
    }, 20);

    return () => {
      clearInterval(scrollInterval);
    };
  }, []);

  return (
    <section id="partners" className="py-6 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-6">
          <p className="text-blue-600 text-sm font-semibold tracking-wider uppercase mb-2" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>
            Technology Partners
          </p>
          <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-3" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif', letterSpacing: '-0.02em' }}>
            Our Technology Partners
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>
            Collaborating with 40+ industry leaders to deliver exceptional, certified IT
            solutions for your business.
          </p>
        </div>

        {/* Partners Carousel - Single Row */}
        <div ref={scrollRef} className="overflow-hidden hide-scrollbar">
          <div className="flex gap-8 w-max">
            {[...partnerLogos, ...partnerLogos].map((logo, index) => (
              <div
                key={`partner-${index}`}
                className="flex-shrink-0 bg-white border-2 border-gray-200 rounded-full hover:border-blue-500 hover:shadow-xl transition-all duration-300 flex items-center justify-center"
                style={{ width: '120px', height: '120px', padding: '20px' }}
              >
                <img
                  src={`/partners/${logo}`}
                  alt={logo.replace('.png', '').replace('.svg', '')}
                  className="w-full h-full object-contain"
                  loading="lazy"
                  style={{ 
                    maxWidth: '80px',
                    maxHeight: '80px',
                    imageRendering: '-webkit-optimize-contrast'
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Footer Text */}
        <div className="text-center mt-6">
          <p className="text-gray-600 font-medium" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>
            Authorized partner & reseller for 40+ global technology brands
          </p>
        </div>
      </div>

      <style jsx>{`
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>
  );
};

export default Partners;